var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#og6z4j9fda)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3lvvwgksb)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.702 8.048C13.555 8.01 13.827 8 16 8s2.445.01 3.298.048c.852.039 1.433.174 1.942.372.534.2 1.018.516 1.417.923.407.4.722.883.923 1.417.198.509.333 1.09.372 1.942.039.853.048 1.125.048 3.298s-.01 2.445-.048 3.298c-.039.852-.174 1.433-.372 1.942a4.09 4.09 0 0 1-2.34 2.34c-.508.198-1.09.333-1.942.372-.853.039-1.125.048-3.298.048s-2.445-.01-3.298-.048c-.852-.04-1.433-.174-1.942-.372a3.921 3.921 0 0 1-1.417-.923 3.921 3.921 0 0 1-.923-1.417c-.198-.509-.333-1.09-.372-1.942C8.01 18.445 8 18.173 8 16s.01-2.445.048-3.298c.039-.852.174-1.433.372-1.942.2-.534.516-1.018.923-1.417.4-.407.883-.722 1.417-.923.509-.198 1.09-.333 1.942-.372zm6.53 1.44c-.843-.038-1.096-.047-3.232-.047s-2.39.009-3.233.047c-.78.036-1.203.166-1.485.276a2.48 2.48 0 0 0-.92.598c-.266.258-.47.572-.598.92-.11.282-.24.705-.276 1.485-.038.844-.047 1.097-.047 3.233s.009 2.39.047 3.233c.036.78.166 1.203.276 1.485.128.348.332.662.598.92.258.266.572.47.92.598.282.11.705.24 1.485.276.844.038 1.097.047 3.233.047s2.39-.009 3.233-.047c.78-.036 1.203-.166 1.485-.276.698-.269 1.25-.82 1.518-1.518.11-.282.24-.705.276-1.485.038-.844.047-1.097.047-3.233s-.009-2.39-.047-3.233c-.036-.78-.166-1.203-.276-1.485a2.478 2.478 0 0 0-.598-.92 2.478 2.478 0 0 0-.92-.598c-.282-.11-.705-.24-1.485-.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.892 16a4.108 4.108 0 1 1 8.216 0 4.108 4.108 0 0 1-8.216 0zm1.441 0a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.27,
    cy: 11.729,
    r: 0.96
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "og6z4j9fda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3lvvwgksb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.716bdeb24e789d6fd8ac31aaaaaa33aa.svg";
export { ForwardRef as ReactComponent };